module.exports = __webpack_public_path__ + "img/209.e96d3539.png";